import React from 'react';
import { useRecoilState } from 'recoil';
import { addToProjectAtom } from '../../../state';
import BadgeButton from './BadgeButton';
import { IProduct, CartItemProps } from '../../../types';
import { CLOUD_FRONT_URL } from '../../../aws.config';

// * Keep all commented code for future reference as cart functionality is still remaining

const CartItem: React.FC<CartItemProps> = ({ product, index }) => {
  const [cartItems, setCartItems] = useRecoilState<IProduct[] | any>(addToProjectAtom);

  const handleQuantityChange = (newQuantity: number) => {
    if (newQuantity < 0) return;

    const updatedCartItems = [...cartItems];
    if (newQuantity === 0) {
      updatedCartItems.splice(index, 1);
    } else {
      updatedCartItems[index] = { ...updatedCartItems[index], quantity: newQuantity };
    }
    setCartItems(updatedCartItems);
  };

  const handleRemoveItem = () => {
    const updatedCartItems = [...cartItems];
    updatedCartItems.splice(index, 1);
    setCartItems(updatedCartItems);
  };

  const renderPillowParts = () => {

    return (
      <div className="flex items-center space-x-4">
        <div>
          <div className="flex items-center justify-center mb-2">
            {product.base64Image ? (
              <img src={`${CLOUD_FRONT_URL}${product.base64Image}`} className="w-16 h-16 object-cover" alt="Front" />
            ) : (
              <img src="/defalutImage.jpg" className="w-16 h-16 object-cover" alt="Front" />
            )}
          </div>
          <p className="text-sm text-center">Front</p>
        </div>
        <div>
          <div className="flex items-center justify-center mb-2">
            {product.base64ImageBack ? (
              <img src={`${CLOUD_FRONT_URL}${product.base64ImageBack}`} className="w-16 h-16 object-cover" alt="Back" />
            ) : (
              <img src="/defalutImage.jpg" className="w-16 h-16 object-cover" alt="Back" />
            )}
          </div>
          <p className="text-sm text-center">Back</p>
        </div>
      </div>
    );
  };

  const renderProductDetails = () => {
    if (product.type === 'pillow') {
      // const { front, back, size, edge, band, insertType } = findPillowParts(product);

      return (
        <div className="space-y-1">
          <p className="font-semibold">{product.seriesName} {product.name}</p>
          {product?.result &&
            Object.entries(product.result).map(([key, value]) => (
              <p key={key} className="text-sm text-gray-600">
                {key}: {value}
              </p>
            ))}
          {/* {front?.name && <p className="text-sm text-gray-600">Front: {front.name}</p>}
          {back?.name && <p className="text-sm text-gray-600">Back: {back.name}</p>}
          {edge && <p className="text-sm text-gray-600">{edge.name}: {edge.finishName}</p>}
          {band && <p className="text-sm text-gray-600">{band.name}: {band.finishName}</p>}
          {insertType && <p className="text-sm text-gray-600">Insert: {insertType.name}</p>} */}
        </div>
      );
    }

    return (
      <div>
        <p className="font-semibold">{product.seriesName} {product.name}</p>
        <p className="text-sm text-gray-600">Product Description</p>
        <p className="text-sm text-gray-500">Size/Details</p>
      </div>
    );
  };

  return (
    <>
      {/* Desktop View */}
      <tr className="border-b hover:!bg-transparent hidden md:table-row">
        <td className="py-4 px-4">
          <div className="flex items-center space-x-4">
            {product.type === 'pillow' ? (
              renderPillowParts()
            ) : (
              <img src={product.modelAtomValue.src} alt="Product" className="w-16 h-16 object-cover" />
            )}
            {renderProductDetails()}
          </div>
        </td>
        <td className="py-4 px-4">
          <div className="flex items-center justify-between">
            <BadgeButton
              quantity={product.quantity}
              onIncrement={() => handleQuantityChange(product.quantity + 1)}
              onDecrement={() => handleQuantityChange(product.quantity - 1)}
            />
            <button
              onClick={handleRemoveItem}
              className="ml-4 text-black"
              aria-label="Remove item"
            >
              <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                <path fillRule="evenodd" d="M9 2a1 1 0 00-.894.553L7.382 4H4a1 1 0 000 2v10a2 2 0 002 2h8a2 2 0 002-2V6a1 1 0 100-2h-3.382l-.724-1.447A1 1 0 0011 2H9zM7 8a1 1 0 012 0v6a1 1 0 11-2 0V8zm5-1a1 1 0 00-1 1v6a1 1 0 102 0V8a1 1 0 00-1-1z" clipRule="evenodd" />
              </svg>
            </button>
          </div>
        </td>
      </tr>

      {/* Mobile View */}
      <div className="md:hidden">
        <div className="flex flex-col space-y-4">
          <div className="flex items-center space-x-4">
            {product.type === 'pillow' ? (
              renderPillowParts()
            ) : (
              <img src={product.modelAtomValue.src} alt="Product" className="w-16 h-16 object-cover" />
            )}
            {renderProductDetails()}
          </div>
          <div className="flex items-center justify-between">
            <BadgeButton
              quantity={product.quantity}
              onIncrement={() => handleQuantityChange(product.quantity + 1)}
              onDecrement={() => handleQuantityChange(product.quantity - 1)}
            />
            <button
              onClick={handleRemoveItem}
              className="ml-4 text-black"
              aria-label="Remove item"
            >
              <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                <path fillRule="evenodd" d="M9 2a1 1 0 00-.894.553L7.382 4H4a1 1 0 000 2v10a2 2 0 002 2h8a2 2 0 002-2V6a1 1 0 100-2h-3.382l-.724-1.447A1 1 0 0011 2H9zM7 8a1 1 0 012 0v6a1 1 0 11-2 0V8zm5-1a1 1 0 00-1 1v6a1 1 0 102 0V8a1 1 0 00-1-1z" clipRule="evenodd" />
              </svg>
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default CartItem; 